import { render, staticRenderFns } from "./voucherTemplateDetail.vue?vue&type=template&id=3766b3df&scoped=true"
import script from "./voucherTemplateDetail.vue?vue&type=script&lang=js"
export * from "./voucherTemplateDetail.vue?vue&type=script&lang=js"
import style0 from "./voucherTemplateDetail.vue?vue&type=style&index=0&id=3766b3df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3766b3df",
  null
  
)

export default component.exports